const advancedSection = $('#advanced-section');
const advancedCardsOverflow = advancedSection.find('.advanced-section-cards-overflow');
const advancedCards = advancedSection.find('.advanced-card-parent');
const advancedBtn = advancedSection.find('.button-parent');

const addAdvancedCardsIn = () => {
    const overflowWidth = pxToVw(advancedCardsOverflow.width());
    const advancedCardsInTL = gsap.timeline({ paused: true });
    advancedCards.each(function (index) {
        advancedCardsInTL.add(
            gsap.fromTo($(this), {
                    x: `100vw`,
                },{
                    x: 0,
                    duration: 1.3,
                    ease: 'pageInEasing',
                }
            ),
            index * 0.1
        );
    });

    return advancedCardsInTL;
};

const addAdvancedInAnimation = () => {
  const gradientConfig = {
    gradient: 'linear-gradient(127deg, #081B48 0%, #8AD1DA 50%, #081B48 100%);',
    start: 120,
    end: 0,
  };

  const sectionInTL = gsap.timeline({
    paused: true,
  });

  sectionInTL.add(
    animateSectionTopperIn({
      sectionParent: advancedSection,
      gradientConfig: gradientConfig,
      descriptorStagger: 0.2,
    }).play(),
    0
  );

  return sectionInTL;

}

const initAdvancedEmbla = () => {
  if (!isDesktop()) {
    const embla = advancedSection.find('.embla');
    const viewport = embla.find('.embla__viewport');
     if (window.EmblaCarousel && viewport.length) {
      const OPTIONS = { align: 'start', dragFree: true };
      const emblaApi = EmblaCarousel(viewport.get(0), OPTIONS);
    }
  }
}

const initAdvancedTrigger = () => {
    if(isDesktop()){
        const advancedSectionInTL = addAdvancedInAnimation();
        const advancedCardsInTL = addAdvancedCardsIn();
        ScrollTrigger.create({
            trigger: advancedSection,
            start: 'top top+=120%',
            end: 'top top+=20%',
            once: true,
            onUpdate: (self) => {
                advancedSectionInTL.progress(self.progress);
            },
        });

        ScrollTrigger.create({
            trigger: advancedSection,
            start: 'top center',
            end: 'top bottom',
            once: true,
            onEnter: () => {
                advancedCardsInTL.play();
            },
        });
    }

  addBtnAnimation(advancedBtn, 60, true);
}

const initAdvancedSection = () => {
    initAdvancedEmbla();
    initAdvancedTrigger();
}

addSectionObserver(advancedSection, initAdvancedSection);